import React from "react";
import { Box, Paper, Typography, CircularProgress } from "@mui/material";

interface UserCountDisplayProps {
  userCount: number | null;
  isFetchingUserCount: boolean;
  viewMode: boolean;
}

export const UserCountDisplay: React.FC<UserCountDisplayProps> = ({
  userCount,
  isFetchingUserCount,
  viewMode,
}) => {
  if (viewMode) return null;

  return (
    <Paper
      sx={{
        position: "fixed",
        top: 80,
        right: 24,
        zIndex: 1000,
        p: 2,
        backgroundColor: "#91278F",
        borderRadius: 2,
        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
        minWidth: "180px",
      }}
      elevation={4}
    >
      <Box display="flex" flexDirection="column" alignItems="center" gap={0.5}>
        <Typography
          variant="caption"
          sx={{
            fontWeight: 500,
            color: "#ffffff",
            textTransform: "uppercase",
            letterSpacing: 0.5,
          }}
        >
          User Count
        </Typography>
        <Box display="flex" alignItems="center" gap={1}>
          {isFetchingUserCount ? (
            <CircularProgress size={20} sx={{ color: "#ffffff" }} />
          ) : (
            <Typography
              variant="h5"
              sx={{
                fontWeight: 700,
                color: "#ffffff",
                minWidth: "60px",
                textAlign: "center",
              }}
            >
              {userCount !== null ? userCount.toLocaleString() : "-"}
            </Typography>
          )}
        </Box>
      </Box>
    </Paper>
  );
};

